export default __webpack_public_path__ + "static/media/phidao.dc673800.png";